import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ index, label, light = false }) => (
  <span
    data-testid={`kicker-${index}`}
    className={`inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.28em] ${
      light ? "text-white/70" : "text-brick"
    }`}
  >
    <span className={`font-display italic text-base normal-case tracking-normal ${light ? "text-white/50" : "text-choc/40"}`}>
      {index}
    </span>
    <span className={`h-px w-10 ${light ? "bg-white/40" : "bg-brick/50"}`} />
    {label}
  </span>
);
